import * as actionTypes from '../actions/actionTypes'

const initialState = {
  loading: false,
  selectedRecord: null,
  company: []
}

const fetchCompanyByIdSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    selectedRecord: action.recordData
  }
}

const fetchCompanyStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchCompanySuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    company: action.data
  }
}

const fetchCompanyFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_COMPANY_BY_ID_SUCCESS:
      return fetchCompanyByIdSuccess(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_START:
      return fetchCompanyStart(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_SUCCESS:
      return fetchCompanySuccess(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_FAILED:
      return fetchCompanyFailed(state, action)
    case actionTypes.SIGNOUT_SUCCESS:
    case actionTypes.SIGNOUT_FAILED:
      return { ...initialState }
    default:
      return state
  }
}

export default reducer
